type Props<T> = {
  value: T;
  currentTab: T;
  setValue: React.Dispatch<T>;
  text: string;
};
const Tab = <T,>({ value, currentTab, setValue, text }: Props<T>) => {
  const selected = value === currentTab;
  return (
    <div
      className={`select-none pb-3 ${
        selected
          ? "border-wg-purple cursor-default  border-b-[3px] "
          : "border-black hover:cursor-pointer"
      }`}
      onClick={() => setValue(value)}
    >
      <span
        className={`text-base font-bold ${
          selected ? "text-wg-purple" : "text-black"
        }`}
      >
        {text}
      </span>
    </div>
  );
};

export default Tab;
